import React from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { Feature } from 'bff/models/product';
import commonService from 'utils/commonService';

const ProdFeature: React.FC<IProps> = (props) => {
  /**
   * @description 建立商品特色區塊
   */
  const handleCreateFeature = () => {
    if (!props.features || props.features.length === 0) return;

    const child = _.map(props.features, (feature:Feature, index:number) => {
      return (
        <div className="prod-feature__item" key={index}>
          <div className="prod-feature__item-img" style={props.itemImgStyles && index === 2 ? props.itemImgStyles : {}}>
            {/* <img src={require(`assets/images/${feature.IMAGE_NAME_PC}`)} alt={feature.FEATURE_BRIEF} /> */}
            <img src={commonService.convertImageUrl(feature.IMAGE_NAME_PC)} alt={feature.FEATURE_BRIEF} />
          </div>
          <p>{feature.FEATURE_BRIEF}</p>
        </div>
      );
    });

    return (
      <div className="prod-feature__items">
        {child}
      </div>
    );
  };

  return (
    <div className="prod-feature" id={props.isPet ? 'prod-feature-pet' : undefined}>
      <div className="template-container">
        <div className="template-content">
          <div className="prod-feature__title-section">
            <div className="prod-feature__title">商品特色</div>
          </div>
          {handleCreateFeature()}
        </div>
      </div>
    </div>
  );
};

export default ProdFeature;
